import {AbstractModel, DateConverter, JsonObject, JsonProperty} from 'projects/core/src/public-api';

@JsonObject('model.ProductionPlanningPost')
export class ProductionPlanningPost extends AbstractModel {

  @JsonProperty(Number, 'id')
  id: number;

  @JsonProperty(Number, 'pos')
  pos?: number;

  @JsonProperty(Number, 'defaultCapacity')
  defaultCapacity?: number;

  @JsonProperty(Number, 'averageDurationPerUser')
  averageDurationPerUser?: number;

  @JsonProperty(Number, 'concurrentJobsQty')
  concurrentJobsQty?: number;

  @JsonProperty(String, 'name')
  name?: string;

  weekToReview?: Date;

  @JsonProperty([Number], 'userIds')
  userIds?: number[];

  @JsonProperty([String], 'roles')
  roles?: string[];

}
